import { Component, ElementRef, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';

declare let document: any;
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-input-grid-legacy',
  styleUrls: ['./input-grid.component.scss'],
  templateUrl: './input-grid.component.html'
})
export class InputGridComponent implements OnInit {
  @Input() autoAddNewRow = true;

  private _rowData: Array<any> = [];
  @Input()
  get rowData(): Array<any> {
    // eslint-disable-next-line eqeqeq
    if (this.autoAddNewRow && (this.isLastRowDirty() || this._rowData.length == 0)) {
      this.addNewRow();
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this._rowData;
  }
  set rowData(value: Array<any>) {
    this._rowData = value;
  }

  get rowDataTrimmed(): Array<any> {
    const lastRow = this._rowData.length - 1;
    if (!this.isLastRowDirty()) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return this._rowData.slice(0, lastRow);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return this._rowData;
    }
  }

  columnDefs: Array<any> = [
    { class: 'column-width-50-percent', field: 'name', label: 'Name' },
    { class: 'column-width-50-percent', field: 'email', label: 'Email' }
  ];

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {}

  addNewRow(): void {
    let newElement = {};

    this.columnDefs.forEach((colDef) => {
      newElement[colDef.field] = null;
    });

    this._rowData.push(newElement);
  }

  removeRow(rowIndex: number): void {
    this.rowData.splice(rowIndex, 1);
  }

  isLastRowDirty(): boolean {
    // eslint-disable-next-line eqeqeq
    if (this._rowData.length === 0) {
      return;
    }

    let lastRow = this._rowData[this._rowData.length - 1];
    let isDirty = false;

    this.columnDefs.forEach((colDef) => {
      if (lastRow[colDef.field]) {
        isDirty = true;
        return;
      }
    });

    return isDirty;
  }

  onKeyUp(event: KeyboardEvent, rowIndex: number, columnIndex: number): void {
    const arrowKeys = ['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'];
    if (!arrowKeys.includes(event.key)) {
      return;
    }
    let cellInput: Partial<HTMLInputElement> = event.target;
    let caretPosition = this.doGetCaretPosition(cellInput);
    switch (event.key) {
      case 'ArrowUp':
        if (caretPosition === 0) {
          rowIndex -= 1;
          if (rowIndex < 0) {
            rowIndex = this.rowData.length - 1;
          }
        }
        break;
      case 'ArrowLeft':
        if (caretPosition === 0) {
          columnIndex -= 1;
          if (columnIndex < 0) {
            columnIndex = this.columnDefs.length - 1;
          }
        }
        break;

      case 'ArrowDown':
        if (caretPosition === cellInput.value.length) {
          rowIndex += 1;
          if (rowIndex >= this.rowData.length) {
            rowIndex = 0;
          }
        }
        break;
      case 'ArrowRight':
        if (caretPosition === cellInput.value.length) {
          columnIndex += 1;
          if (columnIndex >= this.columnDefs.length) {
            columnIndex = 0;
          }
        }
        break;
    }

    this.setCellFocus(rowIndex, columnIndex);
  }

  resetCellClass(): void {
    let cells = this.elementRef.nativeElement.querySelectorAll('td.column-data');

    cells.forEach((cell) => {
      this.renderer.removeClass(cell, 'focus');
    });
  }

  addCellFocusClass(rowIndex: number, columnIndex: number): void {
    this.resetCellClass();

    let selector = `.tr-row-${rowIndex} .td-column-${columnIndex}`;
    let cell = this.elementRef.nativeElement.querySelector(selector);
    this.renderer.addClass(cell, 'focus');
  }

  setCellFocus(rowIndex: number, columnIndex: number): void {
    this.addCellFocusClass(rowIndex, columnIndex);

    let selector = `.tr-row-${rowIndex} .td-column-${columnIndex} input`;
    let input = this.elementRef.nativeElement.querySelector(selector);
    input.focus();
  }

  doGetCaretPosition = (cellInput: Partial<HTMLInputElement>): number => {
    let iCaretPos = 0;

    // IE Support
    if (document.selection) {
      cellInput.focus();
      let oSel = document.selection.createRange();
      oSel.moveStart('character', -cellInput.value.length);

      // The caret position is selection length
      iCaretPos = oSel.text.length;
      // eslint-disable-next-line brace-style
    }

    // Firefox support
    else if (cellInput.selectionStart || cellInput.selectionStart === 0) {
      iCaretPos = cellInput.selectionStart;
    }

    // Return results
    return iCaretPos;
  };
}
